import type { I18nLocale } from "@/modules/i18n/types"

export const getToolboxActiveHrefs = (locale: I18nLocale): string[] => {
  const features = ["v2/appointments", "toolbox", "job-roles", "advices", "handbook", "insights", "career-service"]
  return features.map(feature => `/${locale}/${feature}`)
}
